// Identifica o worker de notificações da equipe (sem dependências, usado no boot).
export const PUSH_SW_URL = "/push-sw.js";
export function isPushWorker(reg: { active?: { scriptURL?: string } | null; installing?: any; waiting?: any }): boolean {
  const url = reg.active?.scriptURL || reg.waiting?.scriptURL || reg.installing?.scriptURL || "";
  try { return new URL(url).pathname === PUSH_SW_URL; } catch { return false; }
}
